import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useState, useRef } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { dateFormatter } from '../../../../../utils';
import { PHARMACY_INVOICE_FROM } from '../../../../../constants/dropdown';

const TAX_SUMMARY_HEADER = [
  { header: 'GST%', accessor: 'gst' },
  {
    header: 'Taxable Amount',
    accessor: 'TaxableAmount'
  },
  { header: 'CGST Amt', accessor: 'cgst' },
  { header: 'SGST Amt', accessor: 'sgst' }
];

const POS_TABLE_COLUMNS = [
  {
    header: 'Retail No.',
    accessor: 'inv_no'
  },
  {
    header: 'Date',
    accessor: (row) => dateFormatter(row?.createdAt)
  },
  {
    header: 'Patient Name',
    accessor: 'patient_name'
  },
  {
    header: 'UHID No.',
    accessor: 'uhid'
  }
];

const TABLE_HEADER = [
  {
    header: 'Return No',
    accessor: 'ret_no'
  },
  {
    header: 'Return Date',
    accessor: (row) => dateFormatter(row?.return_date)
  },
  {
    header: 'Retail No.',
    accessor: ''
  },
  {
    header: 'Location Name',
    accessor: (row) => row?.location?.warehouse_name
  },
  {
    header: 'Account Name',
    accessor: ''
  },
  {
    header: 'Adm. No.',
    accessor: ''
  },
  {
    header: 'Pay Mode',
    accessor: 'pay_mode'
  },
  {
    header: 'Net Amount',
    accessor: 'net_amt'
  },
  {
    header: 'Created At',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const initialConsignmentDataObj = {
  data: [],
  loading: false
};

const initialRetailPos = {
  data: [],
  loading: false
};
export const RetailSaleReturn = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [consignmentDataObj, setConsignmentDataObj] = useState(initialConsignmentDataObj);
  const [retailPosDataObj, setRetailPosDataObj] = useState(initialRetailPos);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [warehouse, setWareHosue] = useState([]);
  const [posDialogueOpen, setPosDialogueOpen] = useState(false);
  const [selectedPos, setSelectedPos] = useState([]);
  const [inputValues, setInputValues] = useState([]);
  const [totalSum, setTotalSum] = useState(0);
  const [tax, setTax] = useState(null);
  const user = JSON.parse(localStorage.getItem('user'));
  const [accountLedger, setAccountLedger] = useState([]);

  useEffect(() => {
    setInputValues((prevValues) => {
      const updatedValues = { ...prevValues };
      detailList.forEach((item) => {
        if (item._id && !updatedValues[item._id]) {
          updatedValues[item._id] = {
            ...item,
            Return_Qty: prevValues[item._id]?.Return_Qty || ''
          };
        }
      });
      return updatedValues;
    });
  }, [detailList]);

  const handleSumChange = (newSum) => {
    setTotalSum(newSum);
    setValue('item_total_amt', totalSum);
  };

  const handleInputChange = (id, Return_Qty, value) => {
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [id]: {
        ...prevInputValues[id],
        [Return_Qty]: value
      }
    }));
  };

  const formatDateToMonthYear = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long' };
    return date.toLocaleDateString('en-US', options);
  };
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        // invoice_no: Yup.string().required(' '),
        // invoice_from: Yup.string().required(' '),
      })
    ),
    defaultValues: {
      return_date: new Date().toISOString().split('T')[0]
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;
  const column = watch('view_column');

  const BILL_TABLE_HEADER = [
    {
      header: 'Retail No.',
      accessor: (row) => row?.inv_no
    },
    column ? { header: 'Product Id', accessor: 'product_id' } : null,
    { header: 'Product Name', accessor: (row) => row?.product?.main?.name },
    { header: 'Billed/Pending Qty', accessor: 'bill_qty' },
    { header: 'Return_Qty', accessor: 'return_qty' },
    { header: 'Rate', accessor: 'mrp' },
    { header: 'Amounts', accessor: 'amount' },
    { header: 'Gst Per.', accessor: 'gst' },
    { header: 'Batch No.', accessor: 'batch_no' },
    { header: 'Exp Date', accessor: (row) => formatDateToMonthYear(row?.exp_date) }
  ].filter(Boolean);

  const itemTotalAmt = watch('item_total_amt');
  const billDisc = watch('bill_dis');
  if (itemTotalAmt !== undefined && billDisc !== undefined) {
    const discountAmount = (billDisc / 100) * itemTotalAmt;
    const netAmt = itemTotalAmt - discountAmount;
    if (netAmt !== watch('net_amt')) {
      setValue('net_amt', netAmt);
    }
  }
  useEffect(() => {
    if (detailList.length > 0) {
      const { gst } = detailList[0];
      const TaxableAmount = itemTotalAmt;
      const totalGstAmount = (TaxableAmount * gst) / 100;
      const cgst = totalGstAmount / 2;
      const sgst = totalGstAmount / 2;
      setTax([{ gst, TaxableAmount, cgst, sgst }]);
    }
  }, [detailList, itemTotalAmt]);

  useEffect(() => {
    if (selectedPos) {
      const keyValuePair = getKeyPathValue(selectedPos, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'productDetails',
        'uhid'
      ]);

      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      if (Array.isArray(selectedPos?.productDetails)) {
        console.log(setDetailList(selectedPos.productDetails));
        const totalBillQty = selectedPos.productDetails.reduce((acc, item) => acc + item.bill_qty, 0);
        setValue('bill_qty', totalBillQty);
        setValue('bill_dis', selectedPos?.dis_per);
      } else {
        setDetailList([]);
      }
    } else {
      reset();
    }
  }, [selectedPos]);

  useEffect(() => {
    console.log('HELLLLOOOOOOOOOOOOOOOOOOOOOOOOO', detailList);
  }, [detailList]);

  // useEffect(() => {
  //     if (selectedRecord) {
  //         const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
  //             '__v',
  //             '_id',
  //             'createdAt',
  //             'status',
  //             'add_details',
  //             'uhid'
  //         ]);
  //         keyValuePair.forEach(({ key, value }) => setValue(key, value));
  //         setDetailList(selectedRecord.add_details);
  //         setValue('invoice_no', selectedRecord?.invoice_no)
  //         setValue('cnt', selectedRecord?.cnt)
  //         const formattedCrnDate = selectedRecord?.cnt_date
  //             ? new Date(selectedRecord.cnt_date).toISOString().split('T')[0]
  //             : '';
  //         setValue('cnt_date', formattedCrnDate);
  //         const formattedInvoiceDate = selectedRecord?.invoice_date
  //             ? new Date(selectedRecord.invoice_date).toISOString().split('T')[0]
  //             : '';
  //         setValue('invoice_date', formattedInvoiceDate);
  //         setValue('type', selectedRecord?.type)
  //         setValue('supplier', selectedRecord?.supplier)
  //         setValue('location', selectedRecord?.location?._id)
  //         setValue('product_type', selectedRecord?.product_type)
  //         setValue('invoice_from', selectedRecord?.invoice_from)
  //         setValue('amd_no', selectedRecord?.amd_no)
  //         setValue('remarks', selectedRecord?.remarks)
  //         setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
  //         setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));

  //     } else {
  //         reset();
  //     }
  // }, [selectedRecord]);

  const formSubmit = async (formValues) => {
    if (detailList.length === 0) {
      toast('Please add the Details first', { variant: 'warning' });
      return;
    }
    setLoading(true);
    const updatedDetailList = detailList.map((item) => {
      const returnQty = inputValues[item.product?._id] ? inputValues[item.product?._id].Return_Qty : null;
      if (item.bill_qty < returnQty) {
        toast(`The Return Qty Can not Be more than bill Qty `, { variant: 'warning' });
        return;
      }
      return {
        ...item,
        Return_Qty: returnQty,
        product: item.product?._id
      };
    });
    console.log(updatedDetailList, 'HELLLO DETAILLIST MAP');
    const payload = { ...formValues, productDetails: updatedDetailList, taxDetails: tax };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/retail-sale-return-update' : '/retail-sale-return-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success && response.data) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Retail Sale Return`, { variant: 'success' });
      setSelectedRecord(response?.data);
      setCurrentAction();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Retail Sale Return`, { variant: 'error' });
    }

    setLoading(false);
  };

  const handleRowDelete = (rowId) => {
    setDetailList((prev) =>
      prev.filter((data) => {
        return data.product !== rowId;
      })
    );
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/consignment-receipt-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Retail Sale Return', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Retail Sale Return', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setConsignmentDataObj({ loading: true });
    const response = await request('/retail-sale-return-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setConsignmentDataObj({ loading: false, data: response.data });
      setOriginalData(sortedData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setConsignmentDataObj({ loading: false });
    }
  };

  const handleFetchPos = async () => {
    setPosDialogueOpen(true);
    setRetailPosDataObj({ loading: true });
    try {
      const response = await request('/retail-sale-list', { method: 'GET' });
      if (response.success) {
        const returnResponse = await request('/retail-sale-return-list', { method: 'GET' });
        if (returnResponse.success) {
          const returnInvNos = new Set(
            returnResponse.data.map((returnItem) => returnItem.productDetails.map((item) => item.inv_no)).flat()
          );
          const filteredData = response.data.filter((sale) => {
            return !returnInvNos.has(sale.inv_no);
          });
          const sortedData = filteredData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          setRetailPosDataObj({ loading: false, data: sortedData });
          setSelectedPos({ loading: false, data: sortedData });
        } else {
          toast('Error in fetching retail sale return data', { variant: 'error' });
          setRetailPosDataObj({ loading: false });
        }
      } else {
        toast('Error in fetching retail sale data', { variant: 'error' });
        setRetailPosDataObj({ loading: false });
      }
    } catch (error) {
      toast('An unexpected error occurred', { variant: 'error' });
      setRetailPosDataObj({ loading: false });
    }
  };

  useEffect(() => {
    if (consignmentDataObj.data && consignmentDataObj.data.length > 0) {
      setOriginalData(consignmentDataObj.data);
      setIsFiltered(false);
    }
  }, [consignmentDataObj.data]);

  useEffect(() => {
    handleUhidSearch();
  }, [input]);

  const handleUhidSearch = () => {
    const lowercasedInput = input.toLowerCase();
    const filtered = consignmentDataObj.data.filter((item) =>
      item.invoice_no?.toString().toLowerCase().includes(lowercasedInput)
    );
    setOriginalData(filtered);
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const getWarehouseDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('location', defaultState?._id);
    }
    setWareHosue(data);
  }, []);

  const getAccountLedgerData = useCallback(async () => {
    const data = await dropdownFetch('account-ledger');
    setAccountLedger(data);
  }, []);

  useEffect(() => {
    getWarehouseDropdown();
    getAccountLedgerData();
  }, [getWarehouseDropdown, getAccountLedgerData]);
  const summary = watch('show_summary');

  useEffect(() => {
    const totalReturnQty = Object.values(inputValues).reduce((total, item) => {
      const qty = parseFloat(item.Return_Qty) || 0;
      return total + qty;
    }, 0);
    setValue('ret_qty', totalReturnQty);
  }, [inputValues, setValue]);

  useEffect(() => {
    console.log('HELLLO DETAILLIST', detailList);
  }, [detailList]);
  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Retail Return
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn id={'Exit'} variant="contained">
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Retail No.</Typography>
                  <SelectTag disabled formControlSX={{ flex: 0.4 }} name="retail_no" />
                  <Typography sx={{ flex: 0.22, fontWeight: 700, fontSize: '1.4rem' }}>Location</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.4 }}
                    name="location"
                    placeholder="Location"
                    menus={warehouse.map((data) => ({ ...data, name: data.warehouse_name }))}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Ret No.</Typography>
                  <TextField disabled sx={{ flex: 0.3 }} name="ret_no" placeholder="Ret No" />
                  <Typography sx={{ flex: 0.22, fontWeight: 700, fontSize: '1.4rem' }}>Return Date</Typography>
                  <TextField disabled sx={{ flex: 0.4 }} name="return_date" placeholder="Return Date" type="date" />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.18, fontWeight: 700, fontSize: '1.4rem' }}>Account</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.9 }}
                    name="account"
                    placeholder="Select Account"
                    menus={accountLedger.map((data) => ({
                      ...data,
                      name: data.ledger_name,
                      _id: data?._id
                    }))}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.18, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.85 }}
                    name="remarks"
                    placeholder="Enter Reason For Return"
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.18, fontWeight: 700, fontSize: '1.4rem' }}>Paymode</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.9 }}
                    name="pay_mode"
                    placeholder="Paymode"
                    menus={PHARMACY_INVOICE_FROM}
                  />
                </Stack>
              </Stack>
            </Box>
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', flexDirection: 'column', gap: 1, boxShadow: '0px 2px 2px #0099ff' }}
            >
              <Stack spacing={1} direction="row" justifyContent="space-between">
                <Button
                  variant="contained"
                  disabled={!['new', 'edit'].includes(currentAction)}
                  onClick={() => {
                    setPosDialogueOpen(true);
                    handleFetchPos();
                  }}
                >
                  Add Details
                </Button>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Checkbox
                    formControlSX={{ flex: 0.8 }}
                    name="view_column"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    fontSize={18}
                  />
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>
                    View All Columns in Table
                  </Typography>
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Checkbox
                    formControlSX={{ flex: 0.8 }}
                    name="show_summary"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    fontSize={18}
                  />
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Show Summary</Typography>
                </Stack>
              </Stack>
              <Table
                containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                data={detailList.map((data) => ({
                  _id: data.product._id,
                  ...data
                }))}
                columns={BILL_TABLE_HEADER}
                size="small"
                showInputField={true}
                handleInputChange={handleInputChange}
                inputValues={inputValues}
                loading={loading}
                onSumChange={handleSumChange}
              />
            </Grid>
            {summary && (
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2} minHeight={'5rem'}>
                <Table
                  containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                  data={tax || []}
                  columns={TAX_SUMMARY_HEADER}
                  size="small"
                  onDeleteHandler={handleRowDelete}
                />
                <Stack sx={{ flex: 1 }} spacing={0.5} direction="column">
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}> Bill Qty</Typography>
                    <TextField disabled sx={{ flex: 0.3 }} name="bill_qty" />
                    <Typography sx={{ flex: 0.38, fontWeight: 700, fontSize: '1.4rem' }}>Return Qty</Typography>
                    <TextField name="ret_qty" disabled sx={{ flex: 0.3 }} />
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Item Tot. Amt</Typography>
                    <TextField disabled sx={{ flex: 0.25 }} name="item_total_amt" />
                  </Stack>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Bill Dis</Typography>
                    <TextField disabled sx={{ flex: 0.32 }} name="bill_dis" />
                    <Typography sx={{ flex: 0.38, fontWeight: 700, fontSize: '1.4rem' }}>Round Off</Typography>
                    <TextField disabled sx={{ flex: 0.3 }} name="round_off" />
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Net Amount</Typography>
                    <TextField disabled sx={{ flex: 0.27 }} name="net_amt" />
                  </Stack>
                </Stack>
              </Stack>
            )}
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Sales Return Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{ 
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
             }}
            label="Search Consignment Receipt"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={originalData || []}
          loading={consignmentDataObj.loading}
          onRowClick={(row) => {
            delete row.patient;
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        open={posDialogueOpen}
        onClose={() => setPosDialogueOpen(false)}
        PaperProps={{ sx: { width: '50%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Select Bill No.
          </Typography>
          <IconButton onClick={() => setPosDialogueOpen(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            variant="outlined"
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={POS_TABLE_COLUMNS}
          data={retailPosDataObj?.data || []}
          loading={retailPosDataObj.loading}
          onRowClick={(row) => {
            setPosDialogueOpen(false);

            // Add inv_no to each item in productDetails
            const detailListWithInvNo = row.productDetails.map((item) => ({
              ...item, // Spread the existing properties of each product detail
              inv_no: row?.inv_no // Add the inv_no to each product detail
            }));

            setDetailList(detailListWithInvNo); // Set the updated list with inv_no included in each product detail

            // Calculate the total bill_qty
            const totalBillQty = row.productDetails.reduce((acc, item) => acc + item.bill_qty, 0);
            setValue('bill_qty', totalBillQty);

            // Set the discount percentage
            setValue('bill_dis', selectedPos?.dis_per);
          }}
        />
      </Dialog>
    </>
  );
};
